module.exports = __webpack_public_path__ + "static/004-6910a28b8c06d3d4709b9babcc564a24.jpg";